import { Matrix4, Plane, Vector3 } from "three";
import { UUID } from "../../utils/typeDefinitions";
import EditHandleTypeEnum from "../../enums/EditHandleTypeEnum";
import SceneObjectData from "./SceneObjectData";
import SceneObjectTypeEnum from "./SceneObjectTypeEnum";
import CommandIdEnum from "../../enums/CommandIdEnums";

class EditHandleData extends SceneObjectData {
    ownerUuid: UUID;
    handleType: EditHandleTypeEnum;
    position: Vector3;
    commandId: CommandIdEnum;
    applyDelta?: (data: SceneObjectData, localDelta: Vector3) => void;
    plane?: Plane;
    direction?: Vector3;

    constructor(
        ownerUuid: UUID,
        handleType: EditHandleTypeEnum,
        position: Vector3,
        commandId: CommandIdEnum,
        applyDelta?: (data: SceneObjectData, localDelta: Vector3) => void,
        plane?: Plane,
        direction?: Vector3
    ) {
        super(SceneObjectTypeEnum.EditHandle);
        this.ownerUuid = ownerUuid;
        this.handleType = handleType;
        this.position = position.clone();
        this.commandId = commandId;
        this.applyDelta = applyDelta;
        this.plane = plane;
        this.direction = direction?.clone();
    }

    clone(): this {
        return new EditHandleData(
            this.ownerUuid,
            this.handleType,
            this.position.clone(),
            this.commandId,
            this.applyDelta,
            this.plane?.clone(),
            this.direction?.clone()
        ) as this;
    }

    applyMatrix4(matrix: Matrix4): void {
        this.position.applyMatrix4(matrix);
    }
}

export default EditHandleData;
